export const config = {
  keyOfLGS: "lessonsLGS",
  linkKeyOfLGS: "branch_io_link_lgs_lp",
  keyOfYKS: "lessonsYKS",
  linkKeyOfYKS: "branch_io_link_yks_lp",
};
